
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAolColourOff as ObiLightAolColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-aol-colour-off.js';
 
 
 

 
 export const ObiLightAolColourOff = createComponent({
   react: React,
   tagName: 'obi-light-aol-colour-off',
   elementClass: ObiLightAolColourOffElement,
   events: {
     
   }
  });
 
 